export function Booked() {
  return "Booking confirmed!";
}
